<template xmlns="http://www.w3.org/1999/html">
  <div class="rlzy">
    <jzcgheader></jzcgheader>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mbx">
        <el-breadcrumb-item  :to="{ path: '/jicailist' }">集中采购</el-breadcrumb-item>
        <el-breadcrumb-item >需求详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div> 
        <div style="background-color: white;"> 
          <div style="display: flex;padding:19px 0px 0 23px;"> 
          <div style="flex:1;"> 
            <div style="display: flex;"> 
              <div style="width:30px;"> 
                <el-image
      style="width: 30px; height: 30px"
      :src="require('../../assets/jzcg/xvqiu.png')"
      :fit="'fill'"></el-image>
              </div>
              <div style="flex:1;line-height: 30px;font-size:24px;color:#333333;margin-left:17px;"> 
               {{baseInfo.title}}
              </div>
            </div>
            <div style="color:#999999;font-size: 14px;line-height: 20px;margin:12px 0px;"> 
              <span style="display: inline-block;width:270px;">发布于 {{baseInfo.createTime}}</span>
              <span>截止于 {{baseInfo.endTime}}</span>
            </div>
          </div>
          <div style="width:200px;text-align: center;"> 
            <el-button v-if="baseInfo.state==2" type="info" style="border-radius: 25px;margin-top: 6px;">已截止</el-button>
            <el-button v-if="baseInfo.state==1" type="primary" style="border-radius: 25px;margin-top: 6px;">报名中</el-button>
            <p v-if="baseInfo.state==1" style="font-size:14px;color:#FF3E01;line-height: 20px;margin-top:6px;">剩余 {{baseInfo.state==1?baseInfo.days:0 }}天</p>
          </div>
        </div>
        <div style="border-bottom: 1px solid #E6E6E6 ;"> 
        </div>
        <div style="display: flex;padding:34px 37px 34px 27px;"> 
          <div style="width:180px;"> 
            <el-image
      style="width: 150px; height: 150px"
      :src="baseInfo.img==''?require('../../assets/jzcg/moren.png'):baseInfo.img"
      :fit="'fill'"></el-image>
          </div>
          <div  style="flex:1;display: flex;">
            <div style="flex:1;"> 
              <p style="color:#333333;font-size: 20px;line-height: 29px;font-weight: 500;margin-top:20px;">{{baseInfo.tenantName}}</p>
            <p style="color:#999999;font-size: 16px;line-height: 23px;margin-top:23px;">联系人：{{baseInfo.contactPerson}}</p>
            <p style="color:#999999;font-size: 16px;line-height: 23px;margin-top:6px;">联系方式：{{baseInfo.contactPhone}}</p>
            </div> 
            <div v-if="baseInfo.isMe" style="width:320px;"> 
              <el-button type="primary" style="margin-top: 57px;float:right;" @click="btnBaomingInfo">报名信息&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&gt;</el-button>
            </div>
            <div v-if="!baseInfo.isMe" style="width:320px;padding-top:78px;"> 
              <div v-if="!baseInfo.isEnlists&&baseInfo.isMe==false&&baseInfo.state==1"  style="margin-left: 35px;float:right;width:140px;height:35px;display: flex;cursor: pointer;margin-top:-20px;" size="mini" @click="btnBaoming(baseInfo.id)">
                  <div  style="width:40px;background-color: #0751D4 ;border-radius: 10px 0 0 10px;text-align: center;padding-top:8px;"> 
                    <el-image
      style="width: 20px; height: 20px;"
      :src="require('../../assets/jzcg/yibaoming.png')"
      :fit="'fill'"></el-image>
                  </div>
                  <div  style="flex:1;background-color: #1266F9 ;text-align: center;line-height: 35px;border-radius:0 10px 10px 0;font-size:16px;color:white;"> 
                    <p style="">立即报名</p>
                  </div>
             
                </div>
                <div v-if="!baseInfo.isEnlists&&baseInfo.isMe==false&&baseInfo.state==2"  style="margin-left: 35px;float:right;width:140px;height:35px;display: flex;cursor: pointer;margin-top:-20px;" size="mini">
                  <div  style="width:40px;background-color:  #909399 ;border-radius: 10px 0 0 10px;text-align: center;padding-top:8px;"> 
                    <el-image
      style="width: 20px; height: 20px;"
      :src="require('../../assets/jzcg/yibaoming.png')"
      :fit="'fill'"></el-image>
                  </div>
              
                  <div  style="flex:1;background-color: #909399 ;text-align: center;line-height: 35px;border-radius:0 10px 10px 0;font-size:16px;color:white;"> 
                    <p style="">立即报名</p>
                  </div>
                </div>
              <div v-if="baseInfo.isEnlists "  style="margin-left: 35px;float:right;width:140px;height:35px;display: flex;cursor: pointer;margin-top:-20px;" size="mini" @click="btnYibaoming">
                  <div style="width:40px;background-color: #B7C3D9;border-radius: 10px 0 0 10px;text-align: center;padding-top:8px;"> 
                    <el-image
      style="width: 20px; height: 20px;"
      :src="require('../../assets/jzcg/yibaoming.png')"
      :fit="'fill'"></el-image>
                  </div>
                  <div style="flex:1;background-color: #C9D3E5;text-align: center;line-height: 35px;border-radius:0 10px 10px 0;font-size:16px;color:white;"> 
                    <p style="">我已报名</p>
                  </div>
                </div>
              <div  style="float:right;width:140px;height:35px;display: flex;cursor: pointer;margin-top:-20px;" size="mini" @click="btnContactTwo(baseInfo.id)">
                  <div style="width:40px;background-color: #439C13;border-radius: 10px 0 0 10px;text-align: center;padding-top:8px;"> 
                    <el-image
      style="width: 20px; height: 20px;"
      :src="require('../../assets/jzcg/dianhua.png')"
      :fit="'fill'"></el-image>
                  </div>
                  <div style="flex:1;background-color: #61B932;text-align: center;line-height: 35px;border-radius:0 10px 10px 0;font-size:16px;color:white;"> 
                    <p>联系TA</p>
                  </div>
                </div>
            </div>
          </div>
        </div>
        </div>
        <div> 
          <div style="font-size:20px;background-color: white;margin:29px 0 10px 0;padding:22px 17px 9px 17px;" > 
            <p style="border-left: 2px solid #1266F9;"> 
              <span style="margin-left:9px;">已在线报名<span style="color:#1266F9;"> {{numBaoming}} </span>人</span>
            </p>
          </div>
          <div style="background-color: white;padding-top:6px;" v-if="numBaoming!=0"> 
         
            <div v-for="item in bmList" :key="item.id" style="height:80px;margin:26px 20px 0 17px;border-bottom: 1px solid #E6E6E6 ;display: flex;"> 
              <div style="width:40px;margin-top:10px;"> 
                <el-image
      style="width: 40px; height: 40px"
      :src="require('../../assets/jzcg/zhanghao.png')"
      :fit="'fill'"></el-image>
              </div>
              <div style="flex:1;margin-left:15px;"> 
                <p style="color:#333333;font-size:18px;line-height: 26px;">{{item.tenantName}}</p>
                <p style="color:#999999;font-size:16px;line-height: 23px;margin-top:10px;"><span style="display: inline-block;width:100px;">{{item.contactPerson}}</span><span>{{item.contactPhone}}</span></p>
              </div>
              <div v-if="baseInfo.isMe==true" style="width:220px;text-align: center;"> 
                  <p style="color:#1266F9;font-size:16px;line-height: 23px;margin-top:4px;cursor: pointer;width:100px;margin-left:60px;"><span @click="btnBmxq(item.id)">报名详情 &gt;</span></p>
                  <p style="color:#CDCDCD;font-size:12px;line-height: 17px;margin-top:10px;">{{item.createTime}}</p>
              </div>
              <div v-if="baseInfo.isMe==false" style="width:220px;text-align: center;"> 
                  <p style="color:#999999;font-size:16px;line-height: 23px;margin-top:4px;cursor: pointer;width:220px;margin-left:0px;"><span>(报名详情仅需求发布方可见)</span></p>
                  <p style="color:#CDCDCD;font-size:12px;line-height: 17px;margin-top:10px;">{{item.createTime}}</p>
              </div>
            </div>
            <div style="text-align: center;margin: 20px 0 24px 0;padding-bottom:24px;"> 
              <el-button v-if="numBaoming>5" type="primary" size="mini" style="width:190px;height:30px;" @click="btnSeeMore">查看更多</el-button>
              <p v-if="false" style="color:#999999;font-size:16px;line-height: 23px;">更多报名信息仅发布人可见</p>
            </div>
          </div>
        </div>
        <div style="background-color: white;padding:22px 36px 29px 47px;"> 
          <p style="color:#333333;font-size: 20px;line-height: 29px;font-weight: bold;">描述</p>
          <p style="color:#999999;font-size: 14px;line-height: 20px;margin-top: 20px;">{{baseInfo.description==''?'暂无':baseInfo.description}}</p>
          <!-- <div style="margin-top:40px;"> 
            <el-image
          v-for="item in 2"
          :preview-src-list="['https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg']"
          :key="item.id"
      style="width: 150px; height: 150px;margin-right: 20px;"
      :src="'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'"
      :fit="'fill'"></el-image>
          </div>
          <p style="color:#999999;font-size: 14px;line-height: 20px;margin-top:20px;">{{'需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容需求描述内容'}}</p> -->
        </div>
        <div style="background-color: white;padding:22px 36px 29px 47px;margin-top:30px;"> 
          <p style="color:#333333;font-size: 20px;line-height: 29px;font-weight: bold;">附件</p>
          <div style="margin-top:40px;margin-bottom:20px;"> 
            <el-image
          v-for="item in tupianList"
          :preview-src-list="[item]"
          :key="item.id"
      style="width: 150px; height: 150px;margin-right: 20px;"
      :src="item"
      :fit="'fill'"></el-image>
          </div>
         <div style="margin-top:0px;" v-if="wenjianList.length!=0"> 
          <div v-for="item in wenjianList" :key="item.id" style="display: flex;align-items: center;margin-bottom:10px;">
            <el-image
      style="width: 40px; height: 45px"
      :src="require('../../assets/jzcg/excels.png')"
      :fit="'fill'"></el-image>
      <p style="padding-left:20px;color:#1C66FF;font-size:20px;line-height: 29px;cursor: pointer;" @click="downloadFile(item)">{{item.substring(item.lastIndexOf("/") + 1)}}</p>
          </div>
         </div>
        </div>
        <div style="margin-top:30px;background-color: white;margin-bottom:30px;padding:22px 36px 0px 47px;"> 
          <p style="color:#333333;font-size: 20px;line-height: 29px;font-weight: bold;">集采产品</p>
          <div style="margin-top:30px;">  
          </div>
          <el-row :gutter="20"> 
            <el-col :span="12" v-for="item in prosList" :key="item.id"> 
              <div style="background-color: #F5F6F9;height: 70px;margin-bottom: 20px;padding:20px;font-size:16px;color:#666666;"> 
                <p style="line-height: 23px;"><span style="color:#333333 ;">产品名称：</span><span>{{item.name}}</span></p>
                <p style="line-height: 23px;margin-top:15px;"><span style="color:#333333 ;">计划采集总量：</span><span style="color:#1C66FF;">{{item.planQty}}</span><span> {{item.unit}}</span></p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-if="isEnlistsFlag" style="margin-top:30px;background-color: white;margin-bottom:30px;padding:22px 36px 0px 47px;"> 
          <p style="color:#333333;font-size: 20px;line-height: 29px;font-weight: bold;">报名信息<span style="float:right;color:#999999;font-size:16px;line-height: 23px;font-weight: normal;width:220px;">报名于 {{  bmInfo.createTime}}</span></p>
          <div style="color:#999999 ;"> 
            <p style="margin-top:26px;font-size:16px;line-height: 23px;">
              <span>
                报名企业：
              </span>
              <span style="color:#333333;">
                {{bmInfo.tenantName}}
              </span>
            </p>
            <p style="margin-top:20px;">
              <span style="display: inline-block;width:190px;">联系人：<span style="color:#333333;">{{bmInfo.contactPerson}}</span></span>
              <span style="display: inline-block;width:280px;">联系方式：<span style="color:#333333;">{{bmInfo.contactPhone}}</span></span>
              <span>报名时间：<span style="color:#333333;">{{bmInfo.createTime}}</span></span>
            </p>
          </div>
          <div style="margin-top:30px;">  
          </div>
          <el-row :gutter="20"> 
            <el-col :span="12" v-for="item in bmInfo.products" :key="item.id"> 
              <div style="background-color: #F5F6F9;height: 70px;margin-bottom: 20px;padding:20px;font-size:16px;color:#666666;"> 
                <p style="line-height: 23px;"><span style="color:#333333 ;">产品名称：</span><span>{{item.productName}}</span></p>
                <p style="line-height: 23px;margin-top:15px;"><span style="color:#333333 ;">计划采集总量：</span><span style="color:#1C66FF;">{{item.purchaseQty}}</span><span> {{item.productUnit}}</span></p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <el-dialog title="报名信息" width="840px" append-to-body :visible.sync="dialogTableVisible">
      <div> 
        <div> 
          <div style="color:#999999 ;"> 
            <p style="margin-top:26px;font-size:16px;line-height: 23px;">
              <span>
                报名企业：
              </span>
              <span style="color:#333333;">
                {{baomingInfo.tenantName}}
              </span>
              <div style="float:right;width:140px;height:35px;display: flex;cursor: pointer;margin-top:-30px;" size="mini" @click="btnContact(baomingInfo.id)">
                  <div style="width:40px;background-color: #439C13;border-radius: 10px 0 0 10px;text-align: center;padding-top:8px;"> 
                    <el-image
      style="width: 20px; height: 20px;"
      :src="require('../../assets/jzcg/dianhua.png')"
      :fit="'fill'"></el-image>
                  </div>
                  <div style="flex:1;background-color: #61B932;text-align: center;line-height: 35px;border-radius:0 10px 10px 0;font-size:16px;color:white;"> 
                    <p>联系TA</p>
                  </div>
                </div>
            </p>
            <p style="margin-top:20px;font-size:16px;">
              <span style="display: inline-block;width:190px;">联系人：<span style="color:#333333;">{{baomingInfo.contactPerson}}</span></span>
              <span style="display: inline-block;width:364px;">联系方式：<span style="color:#333333;">{{baomingInfo.contactPhone}}</span></span>
              <span>报名时间：<span style="color:#333333;">{{baomingInfo.createTime}}</span></span>
            </p>
          </div>
        </div>
        <div style="display: flex;margin-top:20px;"> 
          <div style="width:100px;"> 
            <p style="color:#999999;font-size:16px;line-height: 23px;">集采产品：</p>
          </div>
          <div style="flex:1;max-height: 410px;overflow-y: auto;"> 
            <div v-for="item in baomingInfo.products" :key="item.id"> 
              <div style="background-color: #F5F6F9;margin-bottom: 15px;padding:14px;font-size:16px;color:#666666;"> 
                <p style="line-height: 23px;"><span style="color:#333333 ;display: inline-block;width:100px;text-align: right;">产品名称：</span><span>{{item.productName}}</span></p>
                <p style="line-height: 23px;margin-top:11px;"><span style="color:#333333 ;display: inline-block;width:100px;text-align: right;">采购数量：</span><span style="color:#1C66FF;">{{item.purchaseQty}}</span><span> {{item.productUnit}}</span></p>
                <p style="line-height: 23px;margin-top:11px;"><span style="color:#333333 ;display: inline-block;width:100px;text-align: right;">备注：</span><span>{{item.remark}}</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="联系信息" width="500px" append-to-body :visible.sync="dialogTableVisibleNamePhone">
      <div> 
        <p style="font-size:18px;margin-top: 20px;"><span style="display: inline-block;width:130px;">用户名:</span>{{namephoneObj.contactPerson}}</p>
        <p style="font-size:18px;margin-top: 20px;"><span style="display: inline-block;width:130px;">联系方式:</span>{{namephoneObj.contactPhone}}</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {humanpageindex} from "../../request/moudle/jzcg";
import {centerpurchasedetail,centerpurchaseproductlist,centerpurchasejoinpage,centerpurchasejoindetail,getUserNamePhoneTwo} from "../../request/moudle/jizhongcaigou"

import jzcgheader from './jzcgheader'
import config from "../../utils/config";
export default {
  name: "xvqiuxq",
  components:{
    jzcgheader
  },
  data(){
    return {
      userInfo:  this.common.getSessionStorage('userInfo'),
      dialogTableVisible:false,//弹出框
      id:this.$route.query.id,
      baseInfo:{},//基本信息
      prosList:[],//产品列表
      numBaoming:0,//报名总数
      bmList:[],//报名列表
      isEnlistsFlag:false,
      tupianList:[],
      wenjianList:[],
      baomingInfo:{
        products:[]
      },
      bmInfo:{
        products:[]
      },
      namephoneObj:{},
      dialogTableVisibleNamePhone:false,
    }
  },
  created() {
   this.getDetail(this.id);
   this.getPros(this.id);
   this.getBaoming(this.id);
  },
  methods:{
    isImagePath(path) {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
    return imageExtensions.test(path);
},
    //报名列表和总数
    getBaoming(id){
      centerpurchasejoinpage({centerPurchaseId:id}).then(res=>{

        // console.log('报名列表',res.data);
        this.numBaoming=res.data.total;
        this.bmList=res.data.records;
      }).catch();
    },
        //获取产品列表
        getPros(id){
      centerpurchaseproductlist({centerPurchaseId:id}).then(res=>{

        this.prosList=res.data;
      }).catch();
    },
    getDetail(id){
      centerpurchasedetail({id}).then(res=>{


        if(res.code==200){
          this.isEnlistsFlag=res.data.isEnlists;
          this.baseInfo=res.data;
          const arrs=res.data.files.split(',');
        if(arrs.length>0){

          // console.log('资料数组',arrs);
          let arrOne=arrs.filter(item=>{
            return this.isImagePath(item)
          })
       
          let arrTwo=arrs.filter(item=>{
            return !this.isImagePath(item);
          })
          // console.log('资料处理',arrOne,arrTwo);
          this.tupianList=arrOne;
          this.wenjianList=arrTwo.filter(item=>{
            return item!='';
          });
        }
        if(res.data.isEnlists){
  //如果是自己报名
  centerpurchasejoindetail({centerPurchaseId:this.id,tenantId:this.common.getSessionStorage('userInfo').tenant_id}).then(res=>{
          console.log('报名数据',res.data);
          this.bmInfo=res.data;
        }).catch();
        }
        }
      

      
      }).catch();
    },
    login(){
      this.$router.push({
        path:'/login'
      })
    },
    //下载文件
    downloadFile(url){
      // this.$message.error('下载文件'+url);
      // const url = window.URL.createObjectURL(blob);
    // 创建一个 <a> 元素
    const link = document.createElement('a');
    // 设置 <a> 元素的属性
    link.href = url;
    link.download = url.substring(url.lastIndexOf("/") + 1); // 设置下载文件的名称
    // 添加到 DOM 中
    document.body.appendChild(link);
    // 触发点击事件
    link.click();
    // 释放 URL 对象
    window.URL.revokeObjectURL(url);
    // 移除 <a> 元素
    document.body.removeChild(link);
    },
    //已报名
    btnYibaoming(){
      // this.$message.error('已报名');
    },
    //联系他
    btnContact(idP){
      // this.$message.error('联系他');
      if(!this.common.getSessionStorage('userInfo')){
        

    
        this.$msgbox.confirm('您还未登录, 是否去登录?', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '继续浏览',
          type: 'warning'
        }).then(() => {
          window.location.replace(config.pchref)
        })
        return
      
      }else{
        this.namephoneObj={};
        this.dialogTableVisibleNamePhone=true;
        getUserNamePhone({id:idP}).then(res=>{

          this.namephoneObj=res.data;
        }).catch();
      }
    },
    btnContactTwo(idP){
      // this.$message.error('联系他');
      if(!this.common.getSessionStorage('userInfo')){
        

    
        this.$msgbox.confirm('您还未登录, 是否去登录?', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '继续浏览',
          type: 'warning'
        }).then(() => {
          window.location.replace(config.pchref)
        })
        return
      
      }else{
        this.namephoneObj={};
        this.dialogTableVisibleNamePhone=true;
        getUserNamePhoneTwo({id:idP}).then(res=>{

          this.namephoneObj=res.data;
        }).catch();
      }
    },
    btnBaoming(id){
      if(!this.common.getSessionStorage('userInfo')){
        

    
        this.$msgbox.confirm('您还未登录, 是否去登录?', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '继续浏览',
          type: 'warning'
        }).then(() => {
          window.location.replace(config.pchref)
        })
        return
      
      }else{
        this.$router.push({
        path:'/lijibaoming',
        query:{id}
      })
      }
    },
    //报名信息
    btnBaomingInfo(){
      // this.$message.error('报名信息');
      if(this.numBaoming==0){
        this.$message.error('暂无报名');
        return;
      }
      this.$router.push({
        path:'/baomingshuju',
        query:{
          id:this.id
        }
      })
    },
    //报名详情弹框
    btnBmxq(idP){
    
      // this.$message.error('报名详情');
      this.dialogTableVisible=true;
      centerpurchasejoindetail({id:idP}).then(res=>{
        this.baomingInfo=res.data;
      }).catch();
    },
    //查看更多
    btnSeeMore(){


      this.$router.push({
        path:'/baomingshuju',
        query:{
          id:this.id
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
  .rlzy{
    background: #F5F5F5;
    
    .content{
      width: 1200px;
      margin: 0 auto;
      .mbx{
        margin: 25px 0;
      }
    }
  }
</style>